import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Additionalinfo.css';
import Sidebar from '../dashboard/Sidebar';
// import END_URL from '../../config'; 
import { END_URL, IMG_URL } from "../../config.js";
import Dashheader from '../Dash-header/Dashheader';
import uploadBoxDoc from '../../images/doc-icon.svg';
import { useNavigate } from 'react-router-dom';
import UploadPurchase from './UploadPurchase.jsx';
import ProofOfPurchaseImage from '../../components/Images/ProofOfPurchaseImage.jsx';

import UserFooter from '../footer/UserFooter.jsx';

const userToken = sessionStorage.getItem('authToken');

const SuccessModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;
  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: '600px' }}>
        <h2>Success</h2>
        <p>Form submitted successfully!</p>
        <button style={{ margin: '0 auto 0' }} onClick={onClose}>Close</button>
      </div>
    </div>
  );
};


const Additionalinfo = () => {

  const [currentStep, setCurrentStep] = useState(1);

  const [Forward, setForward] = useState(1);

  const [formData, setFormData] = useState([]);
  const [purchaseHistory, setPurchaseHistory] = useState('');
  const [representing, setRepresenting] = useState('');
  const [numRepresented, setNumRepresented] = useState('');
  const [dependents, setDependents] = useState('');
  const [currentMember, setCurrentMember] = useState('');
  const [SuperMarket, setSuperMarket] = useState('');

  const [numRepresentedError, setNumRepresentedError] = useState(false);

  const [MemberNo, setMemberNo] = useState('');

  const [proofOfPurchasePreview, setProofOfPurchasePreview] = useState(null);
  const [otherPaymentError, setOtherPaymentError] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const navigate = useNavigate();

  const [number, setnumber] = useState('');
  const [woolnumber, setwoolnumber] = useState('');





  const [currentMemberError, setcurrentMemberError] = useState(false);

  const [paymentMethods, setPaymentMethods] = useState([]); // []


  const [otherText, setOtherText] = useState('');

  const [proofOfPurchase, setProofOfPurchase] = useState(null);

  const [proofOfPurchaseFile, setproofOfPurchaseFile] = useState(null);

  const [willingToRegister, setWillingToRegister] = useState('');

  const [ConsentCheck, setConsentCheck] = useState('');

  const [errors, setErrors] = useState({});
  
  const [awareOfPricingProblems, setAwareOfPricingProblems] = useState('');
  const [feelTheDeceptive, setFeelTheDeceptive] = useState('');
  const [inconsistencies, setInconsistencies] = useState('');
  const [expandedCategories, setExpandedCategories] = useState({});

  const [selectedType, setSelectedType] = useState('');

  const [productAdded, setProductAdded] = useState(false);

  const [products, setProducts] = useState([]);

  const [isLoading, setisLoading] = useState(false);


  const handleInputChange = (categoryIndex, itemIndex, field, value) => {
    const newFormData = [...formData];
    newFormData[categoryIndex].items[itemIndex][field] = value;
    setFormData(newFormData);
  };

  const AddProduct = () => {
    const newRow = {
      category_id: "",
      product_id: "",
      product_name: "",
      sku_no: "",
      purchased: "",
      quantity: "",
      increase_percent: "",
      priceIncrease: "",
      totalOverpaid: "",
      import_type: "",
    };
    setRows((prevRows) => [...prevRows, newRow]);
    setProductAdded(true);
  };



  const handlePaymentMethodChange = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setPaymentMethods((prev) => [...prev, value]);
    } else {
      setPaymentMethods((prev) => prev.filter((method) => method !== value));
    }
    setOtherPaymentError(false);
  };

  console.log('paymentMethods:', paymentMethods, typeof paymentMethods);



  const handleOtherPaymentChange = (event) => {
    setOtherText(event.target.value);
  };


  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    setProofOfPurchase(file);

    if (file) {
      // Create a preview URL for images and PDFs
      const previewURL = URL.createObjectURL(file);
      setProofOfPurchasePreview(previewURL);
    } else {
      setProofOfPurchasePreview(null);
    }
  };

  const calculateTotalOverpaid = (categoryIndex, itemIndex) => {
    const item = formData[categoryIndex].items[itemIndex];
    return item.quantity * item.priceIncreaseAmount;
  };

  const calculateSum = () => {
    return formData.reduce((sum, categoryData, categoryIndex) => {
      return sum + categoryData.items.reduce((itemSum, item, itemIndex) => {
        return itemSum + calculateTotalOverpaid(categoryIndex, itemIndex);
      }, 0);
    }, 0).toFixed(2);
  };



  const nextStep = () => {
    let valid = true;

    // Validate currentMember selection
    if (!currentMember) {
      setcurrentMemberError(true);
      valid = false;
    } else {
      setcurrentMemberError(false);
    }

    // Validate numRepresented only if representing is 'yes'
    if (representing === 'yes' && (!numRepresented || numRepresented.trim() === '')) {
      setNumRepresentedError(true);
      valid = false;
    } else {
      setNumRepresentedError(false);
    }

    // Validate "Other (Specify)" if 'other' payment method is selected
    if (paymentMethods == 'other' && (!otherText || otherText.trim() === '')) {
      setOtherPaymentError(true);
      valid = false;
    } else {
      setOtherPaymentError(false);
    }

    // Proceed only if all validations pass
    if (valid) {
      setCurrentStep(prevStep => prevStep + 1);
    }
  };


  const prevStep = () => setCurrentStep(prevStep => prevStep - 1);


  useEffect(() => {
    
    if(currentStep > Forward){

      setForward(currentStep);
    }

  }, [currentStep]);

  useEffect(() => {

    const fetchProfileData = async () => {
      const token = sessionStorage.getItem('authToken');
      if (!token) return;

      try {
        const response = await axios.get(`${END_URL}personaldetail`,

          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (response.data) {

          const responsedata = response.data.personaldetail;

          const product_detail = response.data.product_detail;

          const supermarket_used = response.data.supermarket_used;

          const rowsData = product_detail.map((row) => ({

              sku_no: row.sku_no,
              product_id: row.product_id,
              product_name: row.product_name,
              purchased: row.purchased,
              quantity: row.quantity,
              increase_percent:(((row?.product?.actual_price / row?.product?.regular_price) * 100).toFixed(2)),
              noticed_price: row.noticed_price,
              priceIncrease: row.price_increased,
              totalOverpaid: row.totalOverpaid,
              import_type: row.import_type,

          }));
       
          setRows(rowsData);

          setProductAdded(rowsData.length > 0);

          if(rowsData.length > 0){  

              setForward(4);
          }
 
          const totalColes = product_detail.reduce((sum, row) => sum + parseFloat(row.totalOverpaid || 0), 0);

          setSumCoal(totalColes);



          setPurchaseHistory(responsedata?.purchaseHistory || '');
          setRepresenting(responsedata?.representing || '');
          setNumRepresented(responsedata?.numRepresented || '');
          setDependents(responsedata?.dependents || '');

          setCurrentMember(responsedata?.currentMember || '');

          setSuperMarket(supermarket_used || '');
          setnumber(responsedata?.number || '');
  
          setWillingToRegister(responsedata?.willingToRegister || '');
          setAwareOfPricingProblems(responsedata?.awareOfPricingProblems || '');
          setFeelTheDeceptive(responsedata?.feelTheDeceptive || '');
          setInconsistencies(responsedata?.inconsistencies || '');

          setproofOfPurchaseFile(responsedata?.proofOfPurchase || '');

          setConsentCheck(responsedata?.consent || '');

          let methods = responsedata?.paymentMethods;
          if (typeof methods === "string") {
            try {
              methods = JSON.parse(methods);
            } catch (e) {
              methods = [];
            }
          }
          setPaymentMethods(Array.isArray(methods) ? methods : []);


          setOtherText(responsedata?.formData);

        }

      } catch (error) {
        console.error('Error fetching profile data:', error);

      }
    };

    const fetchCategories = async () => {

      const token = sessionStorage.getItem('authToken');
      if (!token) return;

      try {

        const response = await axios.get(`${END_URL}products`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        setProductCategory(response.data.categories);

      } catch (error) {

        console.error('Error fetching categories:', error);
      }

    };

    fetchCategories();

    fetchProfileData();

  }, []);


  const [rows, setRows] = useState([]);

  const [category, setCategory] = useState('');

  const [Productcategory, setProductCategory] = useState([]);

  const [WoolCategory, setWoolCategory] = useState([]);

  const [CaolCategory, setCaolCategory] = useState([]);

  const [amountsum, setSum] = useState('');

  const [SumCoal, setSumCoal] = useState('');

  const [SumWool, setSumWool] = useState('');




  const handlePurChasedChange = (e, row, index) => {

    const selectedValue = e.target.value;

    setRows((prevRows) => {
      const updatedRows = [...prevRows];
      updatedRows[index] = {
        ...prevRows[index],
        purchased: selectedValue,
      };
      return updatedRows;
    });
  };


  console.log('checkrow', rows);

  const handleRemoveRow = (index) => {
    setRows((prevRows) => {
      const updatedRows = [...prevRows];
      updatedRows.splice(index, 1);

      if (updatedRows.length === 0) setProductAdded(false);

      calculateTotalAmount(updatedRows);
      
      return updatedRows;
    });
  };

  const calculateTotalAmount = (updatedRows) => {

    const totalAmount = updatedRows.reduce((acc, row) => {

      return acc + (parseFloat(row.totalOverpaid) || 0);
    }, 0);

    setSumCoal(totalAmount.toFixed(2));

  };





  const handleInputtableChange = (productId, field, value) => {

    setRows((prevRows) => {
      const updatedRows = prevRows.map((row) => {
        if (row.product_id == productId) {
          if (field === 'quantity' || field === 'priceIncrease') {
            const updatedRow = { ...row, [field]: value };

            if (updatedRow.quantity && updatedRow.priceIncrease) {
              const secondInputValue = parseFloat(updatedRow.quantity) || 0;
              const priceIncreaseValue = parseFloat(updatedRow.priceIncrease) || 0;
              updatedRow.totalOverpaid = (secondInputValue * priceIncreaseValue).toFixed(2);
            }

            return updatedRow;
          }

          return { ...row, [field]: value };
        }

        return row;
      });

      calculateTotalAmount(updatedRows);

      return updatedRows;

    });
  };



  const handleCategoryChange = (e, row, index) => {

    const selectedProductId = e.target.value;
    if (!selectedProductId) return;

    const selectedOption = e.target.options[e.target.selectedIndex];
    const selectedProduct = {
      product_id: selectedProductId,
      product_name: selectedOption.getAttribute("data-name"),
      sku_no: selectedOption.getAttribute("data-sku"),
      increase_percent: ((selectedOption.getAttribute("data-price-increase") / selectedOption.getAttribute("data-price-regular")) * 100).toFixed(2),
      price_increase: selectedOption.getAttribute("data-price-increase"),
      category_id: selectedOption.getAttribute("data-category-id"),
      import_type: selectedOption.getAttribute("data-import-type"),
    };

    let totalOverpaid = 0;

     if (row.quantity && selectedProduct.price_increase) {
        const secondInputValue = parseFloat(row.quantity) || 0;
        const priceIncreaseValue = parseFloat(selectedProduct.price_increase) || 0;
        totalOverpaid = (secondInputValue * priceIncreaseValue).toFixed(2);
      }

    const parsedPrice = parseFloat(selectedProduct.price_increase || 0);

    setRows((prevRows) => {
      const updatedRows = [...prevRows];
      updatedRows[index] = {
        ...prevRows[index],
        product_id: selectedProduct.product_id,
        product_name: selectedProduct.product_name,
        sku_no: selectedProduct.sku_no,
        increase_percent: selectedProduct.increase_percent,
        category_id: selectedProduct.category_id,
        import_type: selectedProduct.import_type,
        priceIncrease: parsedPrice,
        totalOverpaid:totalOverpaid
      };
      return updatedRows;
    });

  };




  const handleSubmit = async () => {

    const newErrors = {};

    if (!ConsentCheck) {

      newErrors.ConsentCheck = 'You must agree to the Privacy Policy before submitting.';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    const apiUrl = `${END_URL}personaldetail`;
    const token = sessionStorage.getItem('authToken');

    if (!token) {
      console.error('No token found. User might not be logged in.');
      alert('You must be logged in to submit this form.');
      return;
    }

    setisLoading(true);

    const formDataToSend = new FormData();
    formDataToSend.append('representing', representing);

    formDataToSend.append('numRepresented', numRepresented);
    formDataToSend.append('dependents', dependents);
    formDataToSend.append('currentMember', currentMember);
    formDataToSend.append('number', number);

    formDataToSend.append('willingToRegister', willingToRegister);
    formDataToSend.append('awareOfPricingProblems', awareOfPricingProblems);
    formDataToSend.append('feelTheDeceptive', feelTheDeceptive);

    formDataToSend.append('consent', ConsentCheck);
    // formDataToSend.append('inconsistencies', inconsistencies);
    // formDataToSend.append('fileType', selectedType);


    const rowsData = rows.map((row) => ({
      sku_no: row.sku_no,
      product_id: row.product_id,
      product_name: row.product_name,
      purchased: row.purchased,
      quantity: row.quantity,
      increase_percent: row.increase_percent,
      noticed_price: row.noticed_price,
      priceIncrease: row.priceIncrease,
      totalOverpaid: row.totalOverpaid,
      import_type: row.import_type,

    }));

    formDataToSend.append('rowsData', JSON.stringify(rowsData));


    if (proofOfPurchase) {
      formDataToSend.append('proofOfPurchase', proofOfPurchase);
    }

    try {
      const response = await axios.post(apiUrl, formDataToSend, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      });

      setisLoading(false);

      setShowSuccessModal(true);
      setTimeout(() => {
        setShowSuccessModal(false);
        navigate('/dashboard');
      }, 1000);


    } catch (error) {
      console.error('API Error:', error);

       setisLoading(false);

      alert('Form submission failed. Please check the console for details.');
    }
  };

  const handleMemberChange = (e) => {

    const selectedValue = e.target.value;

    console.log("Selected Member:", selectedValue);

    setCurrentMember(selectedValue);
  };
  const handleImage = async () => {
    try {
      const token = sessionStorage.getItem('authToken');
      const response = await axios.post(`${END_URL}personaldetail/delete-proof`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.status === 200) {
        setproofOfPurchaseFile(null);
        setProofOfPurchase(null);
        if (proofOfPurchasePreview) {
          URL.revokeObjectURL(proofOfPurchasePreview);
          setProofOfPurchasePreview(null);
        }
      }
    } catch (error) {
      console.error('Failed to delete proof of purchase:', error);
      alert('Failed to delete the proof of purchase file. Please try again.');
    }
  };

  useEffect(() => {
    console.log(SuperMarket, 'SuperMarket');

  }, [Productcategory, currentStep]);

  console.log(WoolCategory, 'WoolCategory');

  console.log(SuperMarket, 'SuperMarket');

  console.log(representing, 'representing');

  const [isActive, setIsActive] = useState(false);

  const handleActivate = () => { setIsActive(true); };
  const handleCancel = () => { setIsActive(false); };

  const renderStepOne = () => (

    <>
      <h1>Step 1: Representation & Loyalty</h1>

      <div className="formGroup">

        <p>Are you representing anyone else in this matter?</p>
        <label>
          <input
            type="radio"
            name="representing"
            value="yes"
            checked={representing === 'yes'}
            onChange={(e) => {
              setRepresenting(e.target.value);
              setDependents("");        
              setNumRepresented("");   
            }}
          /> Yes
        </label>
        <label>
          <input
            type="radio"
            name="representing"
            value="no"
            checked={representing === 'no'}
            onChange={e => setRepresenting(e.target.value)}
          /> No
        </label>
      </div>

      {representing === 'yes' && (
        <>
          <div className="formGroup">
            <p>If Yes, how many people?</p>
            <input
              type="text"
              placeholder=""
              value={numRepresented}
              onChange={e => setNumRepresented(e.target.value)}
            />
            {numRepresentedError && (
              <div className="text-danger">This field is required.</div>
            )}
          </div>

          <div className="formGroup">
              <p>Do they depend on you financially?</p>
              <label>
                <input
                  type="radio"
                  name="dependents"
                  value="yes"
                  checked={dependents === 'yes'}
                  onChange={e => setDependents(e.target.value)}
                /> Yes
              </label>
              <label>
                <input
                  type="radio"
                  name="dependents"
                  value="no"
                  checked={dependents === 'no'}
                  onChange={e => setDependents(e.target.value)}
                /> No
              </label>
            </div>

          </>
      )}

     

      <div className="formGroup">
        <p>
          Are you a member of a supermarket rewards program?
        </p>
        <select value={currentMember} onChange={handleMemberChange}>
          <option value="">Select...</option>
          <option value="Woolworths Flybuys">Woolworths Flybuys</option>
          <option value="Not a member">Not a member</option>
        </select>

        {currentMemberError && (
          <div className='text-danger'>The Field is required</div>
        )}

        {currentMember === "Woolworths Flybuys" && (
          <div className="formGroup">
            <p>Please enter your Flybuys Member Number:</p>
            <input
              type="text"
              value={number}
              onChange={e => setnumber(e.target.value)}
            />
          </div>
        )}
      </div>

      <div className="button-cta">

        <button type='button' onClick={handleCancel} className="cancel-btn">Cancel</button>
        <button className="nextButton" onClick={nextStep}>Continue</button>
      </div>
    </>

  );

  const RenderStepTwo = () => {

    return (
      <>
        <h1>Step 2: Purchase History & Price Impact</h1>

        <span className="info-text">Provide details of items purchased. The "Total Overpaid" and grand total will auto-calculate.</span>

        <div className="table-outer coles" >

          <table>

            <thead>
              <tr>
                <th>Product</th>
                <th>Purchased?</th>
                <th>Qty</th>
                <th>Increase %</th>
                <th>Increase ($)</th>
                <th>Total Overpaid</th>

                {productAdded && <th></th>}

              </tr>
            </thead>

            <tbody>

              {rows.length > 0 && rows.map((row, index) => (

                <tr key={index}>

                  <td>

                    <select name="product" value={row.product_id} onChange={(e) => handleCategoryChange(e, row, index)}>

                      <option value="">Select Product</option>

                      {Productcategory &&
                        Productcategory.map((category) => (
                          <optgroup key={category.id} label={category.name}>
                            {category.products &&
                              category.products.map((product) => (
                                <option
                                  key={product.id}
                                  value={product.id}
                                  data-name={product.product_name}
                                  data-sku={product.sku_no}
                                  data-price-increase={product.actual_price}
                                  data-price-regular={product.regular_price}
                                  data-category-id={category.id}
                                  data-import-type={product.import_type}
                                >
                                  {product.product_name}
                                </option>
                              ))}
                          </optgroup>
                        ))}

                    </select>


                  </td>
                  <td>

                    <select name="purchased"  value={row.purchased || ""} onChange={(e) => handlePurChasedChange(e, row, index)} >

                      <option  value="no">N</option>

                      <option value="yes">Y</option>

                    </select>

                  </td>
                  <td>
                    <input
                      type="number"
                      value={row.quantity}
                      onChange={(e) => handleInputtableChange(row.product_id, 'quantity', e.target.value)}
                      disabled={row.purchased !== 'yes'}
                    />
                  </td>

                  <td>
                    <input
                      type="text"
                      value={`${row.increase_percent} %`}
                      onChange={(e) => handleInputtableChange(row.product_id, 'increase_percent', e.target.value)}
                      disabled
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      value={`${row.priceIncrease} $`}
                      disabled
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      value={row.totalOverpaid}
                      disabled
                    />
                  </td>
                  {productAdded && <td>

                    <button type="button" id="RemoveBtn"   onClick={() => handleRemoveRow(index)} class="btn btn--light btn--small">Remove</button>

                  </td>
                  }
                </tr>

              ))}

              <tr>
                <td ></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                {productAdded && <td></td>}
                <td>

                  <button type="button" id="addItemBtn" onClick={AddProduct} class="btn btn--light btn--small">Add Another Item</button>

                </td>

              </tr>

              <tr>

                <td>Grand Total Overpaid:</td>

                <td>$ {SumCoal}</td>

              </tr>

            </tbody>

          </table>

        </div>

        <div className="button-cta">
          <button className="prevButton" onClick={prevStep}>Back</button>
          <button className="nextButton" onClick={nextStep}>Continue</button>
        </div>

      </>);

  };

  const renderStepThree = () => (
    <>
      <h1>Step 3: Referrals & Personal Experience</h1>

      <div className="formGroup">

        <p> Do you know others who might have been similarly affected and would be willing to register? </p>

        <label><input type="radio" name="willingToRegister" value="yes" checked={willingToRegister === 'yes'} onChange={e => setWillingToRegister(e.target.value)} /> Yes</label>
        <label><input type="radio" name="willingToRegister" value="no" checked={willingToRegister === 'no'} onChange={e => setWillingToRegister(e.target.value)} /> No</label>

      </div>


      <div className="formGroup">

        <p>Are you aware of others who experienced similar pricing problems at Woolworths?</p>

        <label><input type="radio" name="awareOfPricingProblems" value="yes" checked={awareOfPricingProblems === 'yes'} onChange={e => setAwareOfPricingProblems(e.target.value)} /> Yes</label>
        <label><input type="radio" name="awareOfPricingProblems" value="no" checked={awareOfPricingProblems === 'no'} onChange={e => setAwareOfPricingProblems(e.target.value)} /> No</label>
      </div>


      <div className="formGroup">

        <p>How do you feel the deceptive pricing affected you?</p>

        <textarea
          value={feelTheDeceptive}
          onChange={e => setFeelTheDeceptive(e.target.value)}
          placeholder="Not specified."
        />

      </div>

      {/* <div className="formGroup">
        <p>Were there other instances where you noticed inconsistancies in pricing at Coles?</p>
        <textarea value={inconsistencies} onChange={e => setInconsistencies(e.target.value)} placeholder="" />
      </div> */}


      <div className="button-cta">
        <button className="prevButton" onClick={prevStep}>Back</button>
        <button className="nextButton" onClick={nextStep}>Continue</button>
      </div>

    </>
  );


  const renderStepFour = () => (
    <>
      <h1>Step 4: Review & Confirm</h1>

      <div className="formGroup">

        <div class="review-summary">
          
              <h3>Please review your changes before saving.</h3>
        
             <dl id="reviewList" class="review-list">

                    <dt>Representing others?</dt>

                    <dd>{representing || "-" }</dd>

                    <dt>Number of people</dt>

                    <dd>{numRepresented || "-"}</dd>

                    <dt>Are they dependents?</dt>

                    <dd>{dependents || "-" } </dd>

                    <dt>Loyalty Program</dt>

                    <dd>{currentMember || "-" }</dd>

                    <dt>Flybuys Number</dt>

                    <dd>{number || "-" }</dd>

                    <dt>Know others affected?</dt>

                    <dd>{willingToRegister || "-" }</dd>

                    <dt>Aware of others with pricing issues?</dt>
                    <dd>{awareOfPricingProblems || "-"}</dd>

                    <dt>How pricing affected you</dt>

                    <dd>{feelTheDeceptive || "-" }</dd>

                    <dt>Purchase History</dt>
                    <dd class="review-table">
                        <table class="review-table">
                          <thead>
                              <tr>
                                <th>Product</th>
                                <th>Qty</th>
                                <th>Increase</th>
                                <th>Overpaid</th>
                              </tr>
                          </thead>
                          <tbody>

                              {rows.map((row, index) => (
                                <tr key={index}>
                                  <td data-label="Product">{row.product_name || "-" }</td>
                                  <td data-label="Qty">{row.quantity || "-" }</td>
                                  <td data-label="Increase">${row.priceIncrease || "-" }</td>
                                  <td data-label="Overpaid">${row.totalOverpaid || "-" }</td>
                                </tr>
                              ))}

                               <tr>
                                  <td ></td>
                                  <td ></td>
                                  <td >Total Amount</td>
                                  <td>$ {SumCoal}</td>
                              </tr>
                
                          </tbody>
                        </table>
                    </dd>
              </dl>

          </div>

      </div>

       <div className="formGroup consent-check">
          <label>
            <input
              type="checkbox"
              name="consent"
              checked={ConsentCheck}

               onChange={(e) => {
                  setConsentCheck(e.target.checked);
                  if (errors.ConsentCheck) setErrors((prev) => ({ ...prev, ConsentCheck: '' }));
                }}
            />
            I confirm the updated details are correct.
          </label>

            {errors.ConsentCheck && <p className="text-red-500 constent-error">{errors.ConsentCheck}</p>}
        </div>

      <div className="button-cta">
        <button className="prevButton" onClick={prevStep}>Back</button>
        <button className="nextButton" onClick={handleSubmit}>{!isLoading ? 'Save Changes' : 'Saving...' } </button>
      </div>


      {showSuccessModal && (

        <div id="saveSuccessAlert" class="saveSuccessAlert" >
              Your details have been updated successfully.
        </div>
      )}

    </>
  );

  const renderStep = () => {
    switch (currentStep) {
      case 1: return renderStepOne();
      case 2: return RenderStepTwo();
      case 3: return renderStepThree();
      case 4: return renderStepFour();
      default: return null;
    }
  };

  const [expanded1, setExpanded] = useState(false);


  return (


    <div className="dashboard-container full-width">

      <Dashheader />

      <div className="container">

        <div className={`row main-row expanded ${expanded1 ? 'mainmenu' : ''}`}>

          <div className="col-12 col-sm-12 col-md-3 col-lg-3">
            <div className="dashboard-side-div">
              <Sidebar />
              <a href="#" className="expand-btn" onClick={(e) => {
                e.preventDefault();
                setExpanded(!expanded1);
              }}><span></span></a>
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md-9 col-lg-9">
            <main className="content">

              <div className="form-container">

                <div className="dashbord-first">

                  <h3>Additional Information</h3>

                  <p>Share any extra purchase details and supporting evidence to strengthen your claim.</p>
                  <div class="chips">
                    <span class="chip info">🧾 Add purchase details</span>
                    <span class="chip warn">📎 Upload supporting files</span>
                  </div>

                </div>

                <div className="additional-info-content table-info">
                  <div className={`content-card ${isActive ? 'active' : ''}`}>
                    <div className="card-header">
                      <div className="card-hcnt">
                        <h2>Your Supplementary Details</h2>
                        <p>Review your current details or make changes using the wizard.</p>
                      </div>
                      <button onClick={handleActivate} className="edit-btn">Edit Information</button>
                    </div>
                    <div className="info-view-cont">
                      <h3>Representation & Loyalty</h3>
                      <div className="row">
                        <div className="col-md-4">
                          <h6>Representing others?</h6>
                          <h5>{representing || "-" }</h5>
                        </div>
                        <div className="col-md-4">
                          <h6>Number of people</h6>
                          <h5>{numRepresented || "-"}</h5>
                        </div>
                        <div className="col-md-4">
                          <h6>Are they dependents?</h6>
                          <h5>{dependents || "-" } </h5>
                        </div>
                        <div className="col-md-4">
                          <h6>Loyalty Program</h6>
                          <h5>{currentMember || "-" }</h5>
                        </div>
                        <div className="col-md-4">
                          <h6>Flybuys Number</h6>
                          <h5>{number || "-" }</h5>
                        </div>

                      </div>

                      <h3>Purchase History</h3>

                      <div className="row">

                        <div className="col-12">
                  
                            {rows && rows.length > 0 ? (

                              <dd class="review-table">
                                    <table class="review-table">
                                      <thead>
                                          <tr>
                                            <th>Product</th>
                                            <th>Qty</th>
                                            <th>Increase</th>
                                            <th>Overpaid</th>
                                          </tr>
                                      </thead>
                                      <tbody>

                                          {rows.map((row, index) => (
                                            <tr key={index}>
                                              <td data-label="Product">{row.product_name || "-" }</td>
                                              <td data-label="Qty">{row.quantity || "-" }</td>
                                              <td data-label="Increase">${row.priceIncrease || "-" }</td>
                                              <td data-label="Overpaid">${row.totalOverpaid || "-" }</td>
                                            </tr>
                                          ))}

                                           <tr >
                                              <td ></td>
                                              <td ></td>
                                              <td >Total Amount</td>
                                              <td>$ {SumCoal}</td>
                                          </tr>
                            
                                      </tbody>
                                      
                                    </table>
                                </dd>
                            ) :(

                                <p>No purchase history has been logged yet.</p>
                            )}

                        </div>

                      </div>

                      <h3>Referrals & Experience</h3>
                      <div className="row">
                        <div className="col-md-4">
                          <h6>Know others affected?</h6>
                          <h5>{willingToRegister || "-" }</h5>
                        </div>
                      
                        <div className="col-md-4">
                          <h6>Aware of others with pricing issues?</h6>
                          <h5>{awareOfPricingProblems || "-" }</h5>
                        </div>

                        <div className="col-md-4">
                          <h6>How pricing affected you:</h6>
                          <h5>{feelTheDeceptive || "Not specified" }</h5>
                        </div>
                        
                      </div>
                    </div>
                  <div className={`info-edit ${isActive ? 'active' : ''}`}>
                    <div className="steps">
                      <ol>
                        <li class={currentStep > 1 ? 'green_flag' : '' || currentStep == 1 ? 'active' : ''} onClick={() => setCurrentStep(1)} role="button" tabindex="0">Representation</li>
                        <li class={currentStep > 2 ? 'green_flag' : '' || currentStep == 2 ? 'active' : ''} onClick={() => {if (Forward >= 2) setCurrentStep(2); }} role="button" tabindex="0">Purchase History</li>
                        <li class={currentStep > 3 ? 'green_flag' : '' || currentStep == 3 ? 'active' : ''} onClick={() => {if (Forward >= 3) setCurrentStep(3); }} role="button" tabindex="0">Experience</li>
                        <li class={currentStep == 4 ? 'active' : ''} onClick={() => {if (Forward ==4) setCurrentStep(4); }} role="button" tabindex="0">Review</li>
                      </ol>
                    </div>
                    <div className="info-form">
                      {renderStep()}
                    </div>
                  </div>
                  </div>
                </div>

              </div>

              <UserFooter />

            </main>
            
          </div>
        </div>
      </div>
      {/* <SuccessModal isOpen={showSuccessModal} onClose={() => setShowSuccessModal(false)} /> */}
    </div>

  );
};

export default Additionalinfo;
